import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React, { FC } from "react";
import CustomBottomTooltip from "shared/components/CustomBottomTooltip";
import { COLOR_WHITE } from "shared/theme/colors";
import { RepairIcon } from "shared/theme/icons/RepairIcon";
import { StyledBox } from "./styled";

type Props = {
  description?: string;
};

export const MaintenanceModeBadge: FC<Props> = ({ description }) => {
  return (
    <>
      <CustomBottomTooltip
        title={
          <Box display="flex" flexDirection="column" rowGap={0.5}>
            <Typography variant="bodySSemiBold" color={COLOR_WHITE}>
              Maintenance Mode
            </Typography>
            {description?.length ? (
              <Typography variant="bodySRegular" color={COLOR_WHITE}>
                {description}
              </Typography>
            ) : null}
          </Box>
        }
      >
        <StyledBox>
          <RepairIcon />
        </StyledBox>
      </CustomBottomTooltip>
    </>
  );
};

export default MaintenanceModeBadge;
